import { customRoutes } from ".front-commerce/customWebModules";

export default () => {
  return customRoutes
    .filter(Boolean)
    .map((routes) => routes())
    .reduce((acc, routes) => [...acc, ...routes], []);
};
